import React from 'react';
import type { FC, SVGAttributes } from 'react';

export const AlfaBankSignBox: FC<SVGAttributes<SVGElement>> = () => (
    <svg fill="none" height="24" viewBox="0 0 25 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path
            clipRule="evenodd"
            d="M12.6039 2C11.1192 2 10.6581 2.879 10.2624 3.99981L6.18252 15.557H8.88796L9.8299 12.8097H15.0355L15.9089 15.557H18.7857L14.8978 3.99981C14.522 2.88258 14.0886 2 12.6039 2ZM12.5326 5.01076H12.4642L10.6147 10.4887H14.2793L12.5326 5.01076ZM19.0939 21.9999H5.9082V19.2696H19.0939V21.9999Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
